<template>
  <v-container
    v-if="!$apollo.loading && getUser !== null"
    fill-height
    fluid
    grid-list-xl
  >
    <v-flex
      xs12
      class="bots"
    >
      <v-tabs v-model="tab">
        <v-tab
          v-for="(n,i) in tabs"
          v-show="checkView(n.id)"
          :key="i"
          :href="`#${n.id}`"
          @click="changeTab(n.id)"
        >
          {{ n.text }}
          <v-tooltip
            v-if="n.id == 'managers'"
            top
          >
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">
                mdi-information-outline
              </v-icon>
            </template>
            {{ $t('bots.managersHint') }}
          </v-tooltip>
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          value="allbots"
        >
          <all-bots v-if="tab =='allbots'" />
        </v-tab-item>
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          value="mybots"
        >
          <user-bots
            v-if="tab =='mybots'"
            @changeTab="changeTab"
          />
        </v-tab-item>
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          value="managers"
        >
          <managers v-if="tab =='managers'" />
        </v-tab-item>
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          value="aumbots"
        >
          <aum-bots v-if="tab =='aumbots' && getUser.is_bot_manager == true" />
        </v-tab-item>
      </v-tabs-items>
    </v-flex>
  </v-container>
</template>

<script>
import AllBots from "@/views/TraderBots/partial/AllBots.vue";
import UserBots from "@/views/TraderBots/partial/UserBots.vue";
import Managers from "@/views/TraderBots/partial/Managers.vue";
import AumBots from "@/views/TraderBots/partial/AumBots.vue";

import { mapGetters } from "vuex";

export default {
  name: "Bots",
  components: {
    AllBots,
    UserBots,
    AumBots,
    Managers
  },
  data() {
    return {
      tab: null,
      tabs: [
        { id: "allbots", text: this.$t("bots.allBots") },
        { id: "mybots", text: this.$t("bots.myActiveBots") },
        { id: "managers", text: this.$t("bots.managers") },
        { id: "aumbots", text: this.$t("bots.aumBots") }
      ]
    };
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  mounted() {
    if (this.$route.params.id != undefined) this.tab = this.$route.params.id;
  },
  methods: {
    checkView(id) {
      if (id == "aumbots" && this.getUser.is_bot_manager == false) return false;
      return true;
    },
    changeTab(tab) {
      this.tab = tab;
      this.$router.push("/traderbots/" + tab);
    }
  }
}
</script>
<style lang="scss" scoped>
.bots {
  .v-tab {
    .v-icon {
      font-size: 15px;
      margin-left: 3px;
    }
  }
}
.v-tabs-items {
  background-color: transparent;
}
</style>
